"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenLocalStorage = void 0;
class TokenLocalStorage {
    constructor(namespace) {
        this.namespace = namespace;
    }
    getToken() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let value = localStorage.getItem(this.namespace);
                value = JSON.parse(String(value || ''));
                return value || '';
            }
            catch (e) {
                return '';
            }
        });
    }
    setToken(value) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                localStorage.setItem(this.namespace, JSON.stringify(value));
                return true;
            }
            catch (e) {
                return false;
            }
        });
    }
}
exports.TokenLocalStorage = TokenLocalStorage;
//# sourceMappingURL=TokenLocalStorage.js.map